// extracted by mini-css-extract-plugin
module.exports = {"forgotPassLink":"LoginModal_forgotPassLink__13Pq7","formLinkBox":"LoginModal_formLinkBox__1PsnK","actionBtn":"LoginModal_actionBtn__3Fuia"};